import React from 'react'
import { SettingsButton }  from './styled-elements'
import Settings from '../../icons/Settings'

const GraphSettingsButton  = ({available,clickHandler}) => {

  if (!available) return null

  const ret = <div style={{ position: 'absolute', zIndex: 21, top: '10px', left: '10px' }}>
    <SettingsButton onClick={clickHandler.bind(this)}>
      <Settings />
    </SettingsButton>
  </div>

  return ret

}

export default GraphSettingsButton



// WEBPACK FOOTER //
// ./src/components/dataViews/controls/GraphSettingsButton.js